module.exports = __webpack_public_path__ + "img/BlueTeamLogo.bb7395fa.png";